import React from 'react';
import { lazyRenderSupportPane } from 'diagnostics-and-support';
import getDrawerPaneId from 'owa-app-pane-group-utils/lib/getDrawerPaneId';
import { DrawerPane, isDrawerPaneVisible } from 'owa-drawer';
import { observer } from 'owa-mobx-react';
import ProjectionContext from 'owa-popout-v2/lib/context/ProjectionContext';
import { container } from '../AppPaneGroup.scss';
import closeAppPane from '../../orchestration/closeAppPane';

export default observer(function SupportPane() {
    const containerRef = React.useRef<HTMLDivElement>(null);
    const targetWindow = React.useContext(ProjectionContext) as Window;
    const paneId = getDrawerPaneId('support');
    const isPaneVisible = isDrawerPaneVisible(paneId, targetWindow);

    const handleDismiss = React.useCallback(() => {
        closeAppPane(paneId);
    }, [paneId]);

    React.useEffect(() => {
        if (isPaneVisible && containerRef.current) {
            lazyRenderSupportPane.importAndExecute(containerRef.current, () => void 0);
        }
    }, [isPaneVisible]);

    if (!isPaneVisible) {
        return null;
    }

    return (
        <DrawerPane paneId={paneId} onDismiss={handleDismiss}>
            <div ref={containerRef} id={paneId} className={container} />
        </DrawerPane>
    );
}, 'SupportPane');
